import { Fragment } from 'react';

import { UnitService as Service } from './UnitService';

import { useToolbar } from '../../../shared/hooks/Toolbar';
import { useDataTable } from '../../../shared/hooks/DataTable';
import { useDialogCrup } from '../../../shared/hooks/DialogCrup';
import { useImExExcel } from '../../../shared/hooks/ImExExcel';
import { ROLE } from '../../../Constant';

export const List = () => {

  const header = 'Đơn vị tính';
  const dataKey = 'id';

  const { render: renderDataTable, refreshLazyData, reloadLazyData, selectedItems, dataTableParams } = useDataTable({
    header,
    dataKey,
    columns: [
      { field: 'code', header: 'Mã đơn vị tính', width: 250, matchMode: 'contains' },
      { field: 'name', header: 'Tên đơn vị tính', minWidth: 250, matchMode: 'contains' }
    ],
    indexColumnWidth: 40,
    getList: (params) => {
      return Service.getList(params);
    }
  });

  const { render: renderDialogCrup, create, update, clone } = useDialogCrup({
    header,
    dataKey,
    width: '40rem',
    fields: [
      { field: 'code', header: 'Mã đơn vị tính', required: true, uppercase: true, InputTextProps: { maxLength: 50 }, className: 'md:col-12' },
      { field: 'name', header: 'Tên đơn vị tính', InputTextProps: { maxLength: 50 }, className: 'md:col-12' }
    ],
    createItem: (item) => {
      return Service.create(item);
    },
    updateItem: (id, item) => {
      return Service.update(id, item);
    },
    refreshLazyData
  });

  const { renderImExExcel, download, showImportDialog } = useImExExcel({
    exportTemplate: () => {
      return Service.downloadExcelTemplate();
    },
    exportExcel: (params) => {
      return Service.downloadExcel(params);
    },
    exportExcelFileName: 'danh-muc-don-vi-tinh',
    importExcel: (data) => {
      return Service.uploadExcel(data);
    },
    reloadLazyData
  });

  const { renderToolbar } = useToolbar({
    dataKey, create, update, clone, reloadLazyData, selectedItems,
    showImportDialog,
    exportExcel: download, dataTableParams,
    deleteItem: (id) => {
      return Service.delete(id);
    },
    createRole: ROLE.CATEGORY_UNIT_CREATE,
    editRole: ROLE.CATEGORY_UNIT_EDIT,
    cloneRole: ROLE.CATEGORY_UNIT_COPY,
    deleteRole: ROLE.CATEGORY_UNIT_DELETE,
    importRole: ROLE.CATEGORY_UNIT_IMPORTEXCEL,
    exportRole: ROLE.CATEGORY_UNIT_EXPORTEXCEL
  });

  return (
    <Fragment>
      {renderToolbar()}
      {renderDataTable()}
      {renderDialogCrup()}
      {renderImExExcel()}
    </Fragment>
  )
}
